import * as React from "react";

const Menu: React.FC = () => {
    return (
        <svg
            width="22"
            height="18"
            viewBox="0 0 22 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <rect y="8.25" width="22" height="1.5" fill="#545454" />
            <rect y="0.25" width="22" height="1.5" fill="#545454" />
            <rect y="16.25" width="22" height="1.5" fill="#545454" />
        </svg>
    );
};

export default React.memo(Menu);
